import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
 
import Wrapper from "../../components/Wrapper";
import { FaPowerOff } from "react-icons/fa";
const ControlPanel = ()=>{
    const [packageinstallation, setPackageinstallation] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingRowId, setLoadingRowId] = useState(null); 
    const [buttonStateChanged, setButtonStateChanged] = useState(null);
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [packageData, setPackageData] = useState(packageinstallation); 
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`packageinstallation?page=${page}`);
            setPackageinstallation(data.data);
            setLastPage(data.meta.last_page);
            packageData.power_status = packageinstallation.power_status;
            console.log(data);

        }
        )();
    },[page]);
    
    const HandleCommands = async (trackingMsisdn,command, rowId)=>{

        try {
            setLoadingRowId(rowId);
            setButtonStateChanged(null);
            const {data} = await axios.post('deviceControl', {
                msisdn:trackingMsisdn,
                command,
            });
            console.log(data);
        } catch (error) {
            
        } finally {
            //setLoadingRowId(null);
            // Simulate loading complete and toggle the power status after 2 seconds
            setButtonStateChanged(rowId);
            setPackageData((prev) => ({
            ...prev,
            power_status: prev.power_status === 1 ? 0 : 1, // Toggle power status
            }));

            console.log(packageData.power_status);
        
        }
    }
    return (
        <Wrapper pageTitle={'Control Panel'}>
            
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Installation date </th>
                                    <th className="px-4 py-3">Client </th>
                                    <th className="px-4 py-3">Solar package </th>
                                    <th className="px-4 py-3">Installation location </th>
                                    
                                    <th className="px-4 py-3">Amount paid </th>
                                    <th className="px-4 py-3">Balance amount </th>
                                    
                                    <th className="px-4 py-3">Tracking MSISDN </th>
                                    <th className="px-4 py-3">Actions  </th> 
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {packageinstallation.map((packageinstallation)=>{
                                         return(
                                             <tr key={packageinstallation.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{packageinstallation.id}</td>
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.installation_date}</td>
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.client.name}</td>
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.SolarPackage.package_name}</td>
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.installation_location}</td>
                                               
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.amount_paid}</td>
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.balance_amount}</td>
                                                
                                                 <td className="px-4 py-3 text-sm">{packageinstallation.tracking_msisdn}</td>
                                                 <td className="px-4 py-3 text-sm">
                                                    {loadingRowId === packageinstallation.id?(
                                                        '....'
                                                    ):(
                                                        <>
                                                        {packageinstallation.power_status === 1 ? ( 

                                                       <Link> <FaPowerOff className="text-red-500" onClick={()=>HandleCommands(packageinstallation.tracking_msisdn,"stop", packageinstallation.id)}/></Link>
                                                   ) : (
 
                                                       <Link><FaPowerOff className="text-green-500" onClick={()=>HandleCommands(packageinstallation.tracking_msisdn,"start", packageinstallation.id)}/></Link>
                                                   )}
                                                        </>
                                                        
                                                    )}
                                                    
                                                    </td>
                                                  
                                               </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default ControlPanel;